import {
    singleSlider,
    isotop
} from "./main.js";
import {
    fromDown,
    staggerfromDown
} from "./revealAnimations.js";
import {
    ScrollTrigger
} from "gsap/dist/ScrollTrigger";
import {
    isotopeInit
} from "./massonryComponent.js";


export function InitLoadMoreBlogs() {

    document.addEventListener('DOMContentLoaded', function() {

        var blogPostsContainer = document.querySelector(".blogPosts");

        const filterButtons = document.querySelectorAll('.bloglist .filter-button');
        const slides = document.querySelectorAll(".swiper .swiper-slide");
        const sortingSelect = document.querySelector('.bloglist #sorting');

        let currentFilter = ''; 
        let currentPage = 1; // Initial page
        let sortOrder = '';

        // Add click event listeners to filter buttons
        filterButtons.forEach(button => {
            button.addEventListener('click', function() {

                // Update the active filter
                currentFilter = this.getAttribute('data-energy-type-key');
                currentPage = 1; // Reset to the first page when filtering
                // Remove active state from all buttons
                filterButtons.forEach((btn) => btn.setAttribute("aria-pressed", "false"));
                // Set active state on the clicked button
                button.setAttribute("aria-pressed", "true");

                // Filter slides
                slides.forEach((slide) => {

                    const slideKey = slide.querySelector("article")?.getAttribute("data-energy-type-key");
                    const recommendedBlogHeader = document.getElementById("recommendedBlogHeader");

                    if (slides.length == 1 && slideKey != currentFilter) {
                        if (!currentFilter) {
                            recommendedBlogHeader.style.display = "flex";
                        } else {
                            recommendedBlogHeader.style.display = "none";
                        }
                    } else {
                        recommendedBlogHeader.style.display = "flex";
                    }

                    if (!currentFilter || slideKey === currentFilter) {
                        slide.style.display = "flex"; // Show the slide
                    } else {
                        slide.style.display = "none"; // Hide the slide
                    }
                });
              
                singleSlider.forEach((slider) => {
                    const sliderEl = slider.querySelector('.singleSlider') && slider.querySelector('.singleSlider').swiper;
                    sliderEl && sliderEl.update();
                });

                //Chech the select sorting order
                sortOrder = sortingSelect ? sortingSelect.value : '';

                // Fetch and display filtered blog posts
                fetchBlogPosts(currentPage, currentFilter, sortOrder);
            });
        });


        // Add click event listeners to sorting select
        sortingSelect && sortingSelect.addEventListener("change", function () {
            const selectedValue = sortingSelect.value;

            const selectedFilterButton = document.querySelector('button[aria-pressed="true"]');
            currentFilter = selectedFilterButton ? selectedFilterButton.getAttribute("data-energy-type-key") : '';

            currentPage = 1;
            fetchBlogPosts(currentPage, currentFilter, selectedValue);
        });



        document.addEventListener('click', function (event) {
            if (event.target && event.target.id === 'blog-load-more') {
                currentPage += 1; // Increment the page
                fetchBlogPosts(currentPage, currentFilter, sortOrder); // Fetch the next set of tips
            }
        });

        function fetchBlogPosts(page ,filter ,sortOrder) {
            fetch(`/umbraco/surface/educational/GetBlogPosts?page=${page}&filter=${filter}&sortorder=${sortOrder}`)
                .then(response => response.text())
                .then(data => {

                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data;

                    if (page === 1) {
                        // Replace the content for the first page
                        blogPostsContainer.innerHTML = tempDiv.querySelector('.blogPosts').innerHTML;
                    } else {
                        // Append new tips for subsequent pages
                        blogPostsContainer.insertAdjacentHTML('beforeend', tempDiv.querySelector('.blogPosts').innerHTML);
                    }

                    const animatedGrid = document.querySelectorAll(".animatedGrid");
                    if (animatedGrid) {
                        animatedGrid.forEach((elem) => {
                            staggerfromDown(elem, elem.querySelectorAll(".staggerfromDown"), 0.7);
                        });
                    }

                    // Update or remove the "Load More" button
                    const newLoadMoreButton = tempDiv.querySelector('#blog-load-more');
                    const existingLoadMoreButton = document.querySelector('#blog-load-more');

                    if (newLoadMoreButton) {
                        if (!existingLoadMoreButton) {
                            // If the "Load More" button doesn't exist, create it
                            blogPostsContainer.insertAdjacentHTML('afterend', newLoadMoreButton.outerHTML);
                        } else {
                            // Update the existing "Load More" button
                            existingLoadMoreButton.setAttribute('data-page', newLoadMoreButton.getAttribute('data-page'));
                        }
                    } else if (existingLoadMoreButton) {
                        // Remove the "Load More" button if there are no more posts
                        existingLoadMoreButton.remove();
                    }

                })
                .catch(error => console.error('Error loading blog posts:', error));
        }
    });
}
export function InitTipsLoadMore() {

    document.addEventListener('DOMContentLoaded', function () {

        const tipsWrapper = document.querySelector('.tipsWrapper'); // Container for tips
        const filterButtons = document.querySelectorAll('.educationaltipslist  .filter-button'); // Filter buttons

        const slides = document.querySelectorAll(".swiper .swiper-slide");

        let currentFilter = ''; // Default filter
        let currentPage = 1; // Initial page

        // Add click event listeners to filter buttons
        filterButtons[0] && filterButtons.forEach(button => {
            button.addEventListener('click', function () {
                // Update the active filter
                currentFilter = this.getAttribute('data-energy-type-key');
                currentPage = 1; // Reset to the first page when filtering

                
                filterButtons.forEach((btn) => btn.setAttribute("aria-pressed", "false"));
                button.setAttribute("aria-pressed", "true");

                // Filter slides
                slides.forEach((slide) => {
                    const slideKey = slide.querySelector("article")?.getAttribute("data-energy-type-key");
                    if (!currentFilter || slideKey === currentFilter) {
                        slide.style.display = "flex"; // Show the slide
                    } else {
                        slide.style.display = "none"; // Hide the slide
                    }
                });

                singleSlider.forEach((slider) => {
                    const sliderEl = slider.querySelector('.singleSlider') && slider.querySelector('.singleSlider').swiper;
                    sliderEl && sliderEl.update();
                });

               


                // Fetch and display filtered tips
                fetchTips(currentFilter, currentPage);
            });
        });

        document.addEventListener('click', function (event) {
            if (event.target && event.target.id === 'tips-load-more') {
                currentPage += 1; // Increment the page
                fetchTips(currentFilter, currentPage); // Fetch the next set of tips
            }
        });

        // Function to fetch tips based on the filter and page
        function fetchTips(filter, page) {
            fetch(`/umbraco/surface/Educational/GetEducationalTips?page=${page}&filter=${filter}`)
                .then(response => response.text())
                .then(data => {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data;

                    if (page === 1) {
                        // Replace the content for the first page
                        tipsWrapper.innerHTML = tempDiv.querySelector('.tipsWrapper').innerHTML;
                    } else {
                        // Append new tips for subsequent pages
                        tipsWrapper.insertAdjacentHTML('beforeend', tempDiv.querySelector('.tipsWrapper').innerHTML);
                    }


                    const animatedGrid = document.querySelectorAll(".animatedGrid");
                    if (animatedGrid) {
                        animatedGrid.forEach((elem) => {
                            staggerfromDown(elem, elem.querySelectorAll(".staggerfromDown"), 0.7);
                        });
                    }


                    // Update or remove the "Load More" button
                    const newLoadMoreButton = tempDiv.querySelector('#tips-load-more');
                    const existingLoadMoreButton = document.querySelector('#tips-load-more');

                    if (newLoadMoreButton) {
                        if (!existingLoadMoreButton) {
                            // If the "Load More" button doesn't exist, create it
                            tipsWrapper.insertAdjacentHTML('afterend', newLoadMoreButton.outerHTML);
                        } else {
                            // Update the existing "Load More" button
                            existingLoadMoreButton.setAttribute('data-page', newLoadMoreButton.getAttribute('data-page'));
                        }
                    } else if (existingLoadMoreButton) {
                        // Remove the "Load More" button if there are no more posts
                        existingLoadMoreButton.remove();
                    }
                })
                .catch(error => console.error('Error loading tips:', error));
        }
    });
    

}
export function InitQaLoadMore() {

    document.addEventListener('DOMContentLoaded', function() {

        const qasContainer = document.querySelector('.qaList');

        const filterButtons = document.querySelectorAll('.educationalqalist .filter-button');

        const slides = document.querySelectorAll(".question-item");

        let currentFilter = ''; // Default filter
        let currentPage = 1; // Initial page

        // Add click event listeners to filter buttons
        filterButtons.forEach(button => {

            button.addEventListener('click', function () {

                // Update the active filter
                currentFilter = this.getAttribute('data-tag-key');
                currentPage = 1; // Reset to the first page when filtering

                // Remove active state from all buttons
                filterButtons.forEach((btn) => btn.setAttribute("aria-pressed", "false"));
                button.setAttribute("aria-pressed", "true");

                var qaItems = document.querySelectorAll('.question .question-item');
                isotop.remove(qaItems)

                fetchQas(currentFilter, currentPage);
               
            });
        });

        // Add click event listener to the "Load More" button
        document.addEventListener('click', function (event) {
            if (event.target && event.target.id === 'qa-load-more') {
                currentPage += 1; // Increment the page
                fetchQas(currentFilter, currentPage); // Fetch the next set of tips
            }
        });

        function fetchQas(filter, page) {
            fetch(`/umbraco/surface/educational/GetEducationalQas?page=${currentPage}&filter=${currentFilter}`)
                .then(response => response.text())
                .then(data => {

                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data;

                    const tempDivIsotope = document.createElement('div');
                    tempDivIsotope.innerHTML = data;
                    const childDivs = tempDivIsotope.querySelectorAll('.question-item');
                    const contentsArray = Array.from(childDivs);
                    console.log("contentsArray", contentsArray);

                    // Get the Isotope container
                    const isotopeContainer = document.querySelector('.question')
                    contentsArray.forEach(element => isotopeContainer.appendChild(element));
                    isotop.appended(contentsArray);
                    isotop.layout();

                    const animatedGrid = document.querySelectorAll(".animatedGrid");
                    if (animatedGrid) {
                        animatedGrid.forEach((elem) => {
                            staggerfromDown(elem, elem.querySelectorAll(".staggerfromDown"), 0.7);
                        });
                    }

                    // Update or remove the "Load More" button
                    const newLoadMoreButton = tempDiv.querySelector('#qa-load-more');
                    const existingLoadMoreButton = document.querySelector('#qa-load-more');

                    if (newLoadMoreButton) {
                        if (!existingLoadMoreButton) {
                            // If the "Load More" button doesn't exist, create it
                            qasContainer.insertAdjacentHTML('afterend', newLoadMoreButton.outerHTML);
                        } else {
                            // Update the existing "Load More" button
                            existingLoadMoreButton.setAttribute('data-page', newLoadMoreButton.getAttribute('data-page'));
                        }
                    } else if (existingLoadMoreButton) {
                        // Remove the "Load More" button if there are no more posts
                        existingLoadMoreButton.remove();
                    }

                })
                .catch(error => console.error('Error loading more posts:', error));
        }



       
    });
}

// SEARCH RESULTS FILTERS
document.addEventListener("DOMContentLoaded", () => {
    const checkboxes = document.querySelectorAll('.checkboxes.searchFilters input[type="checkbox"]');

    function getCheckedValues() {
        return [...checkboxes]
            .filter(checkbox => checkbox.checked)
            .map(checkbox => checkbox.value);
    }

    function handleCheckboxChange() {
        console.log(getCheckedValues()); // Logs updated checked values in an array
    }

    checkboxes.forEach(checkbox => {
        checkbox.addEventListener("change", handleCheckboxChange);
    });
});